import type { Actor } from '@/types/content';

export const actors: Actor[] = [
  {
    id: 'actor-1',
    name: '林知夏',
    birthYear: 1996,
    profession: '演员',
    region: '中国大陆',
    bio: '毕业于中央戏剧学院表演系，以细腻克制的表演风格著称。代表作包括《姐姐的朋友》《姐姐的朋友·重逢》《故里茶香》等。她擅长在沉默与细节中传递人物情绪，被观众称为「最会演眼神戏的年轻演员」。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Chinese%20actress%20with%20soft%20natural%20light%2C%20calm%20thoughtful%20expression%2C%20warm%20neutral%20studio%20background%2C%20clean%20elegant%20aesthetic%2C%20high%20detail%20professional%20photography&width=600&height=800&seq=actor-linzx-photo&orientation=portrait',
    filmIds: ['film-1', 'film-2', 'film-9', 'film-12'],
  },
  {
    id: 'actor-2',
    name: '顾时安',
    birthYear: 1993,
    profession: '演员',
    region: '中国大陆',
    bio: '科班出身，早期活跃于话剧舞台，后转向影视。气质温和内敛，擅长诠释克制而深情的角色。在《姐姐的朋友》系列中饰演江辰一角，被观众熟知。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Chinese%20actor%20with%20short%20dark%20hair%2C%20gentle%20calm%20expression%2C%20soft%20neutral%20studio%20background%2C%20clean%20minimal%20warm%20lighting%2C%20high%20detail%20professional%20photography&width=600&height=800&seq=actor-gusa-photo&orientation=portrait',
    filmIds: ['film-1', 'film-2', 'film-7', 'film-10'],
  },
  {
    id: 'actor-3',
    name: '苏晚晴',
    birthYear: 1998,
    profession: '演员',
    region: '中国大陆',
    bio: '新生代实力派女演员，毕业于北京电影学院。以都市题材作品见长，擅长塑造独立、坚韧的现代女性形象。代表作《她的名字》《追光者》《姐姐的朋友》。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20confident%20young%20Chinese%20woman%20with%20soft%20smile%2C%20warm%20neutral%20studio%20background%2C%20clean%20elegant%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-suwan-photo&orientation=portrait',
    filmIds: ['film-1', 'film-7', 'film-12'],
  },
  {
    id: 'actor-4',
    name: '陆行舟',
    birthYear: 1990,
    profession: '演员',
    region: '中国大陆',
    bio: '被誉为「悬疑剧定海神针」的实力派演员。对角色心理的把握精准，气场沉稳。参演《长夜将明》《雾中灯塔》《逆风旅人》等多部高口碑作品。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20serious%20middle%20aged%20man%20with%20sharp%20eyes%2C%20cool%20neutral%20studio%20background%2C%20clean%20cinematic%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-luxzhou-photo&orientation=portrait',
    filmIds: ['film-4', 'film-6', 'film-10'],
  },
  {
    id: 'actor-5',
    name: '温以宁',
    birthYear: 2000,
    profession: '演员 / 歌手',
    region: '中国大陆',
    bio: '以青春校园题材出道，笑容极具辨识度。兼具演员与歌手身份，在《心跳频率》中自弹自唱，展现音乐才华。代表作《夏日回响》《姐姐的朋友·重逢》。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20with%20long%20hair%2C%20warm%20neutral%20studio%20background%2C%20soft%20clean%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-wenyin-photo&orientation=portrait',
    filmIds: ['film-2', 'film-3', 'film-11'],
  },
  {
    id: 'actor-6',
    name: '周砚',
    birthYear: 1988,
    profession: '演员 / 导演',
    region: '中国大陆',
    bio: '资深演员兼导演，荧幕形象亦正亦邪。既在《长夜将明》《故里茶香》中贡献扎实表演，也执导了青春片《夏日回响》，展现多面才华。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20middle%20aged%20man%20with%20weathered%20face%2C%20neutral%20studio%20background%2C%20moody%20cinematic%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-zhouyan-photo&orientation=portrait',
    filmIds: ['film-4', 'film-6', 'film-9'],
  },
  {
    id: 'actor-7',
    name: '白栀',
    birthYear: 1997,
    profession: '演员',
    region: '中国大陆',
    bio: '气质清冷的文艺片常客，多次出演跨国合拍作品。表演细腻，擅长文艺与科幻题材。代表作《海边的旧信》《星尘之约》。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20gentle%20young%20Asian%20woman%20with%20calm%20expression%2C%20soft%20warm%20neutral%20studio%20background%2C%20clean%20elegant%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-baizhi-photo&orientation=portrait',
    filmIds: ['film-5', 'film-8'],
  },
  {
    id: 'actor-8',
    name: '沈亦白',
    birthYear: 1995,
    profession: '演员',
    region: '中国大陆',
    bio: '戏路宽广的青年演员，既能驾驭青春热血，也能诠释文艺深沉。作风低调，作品口碑稳定。代表作《夏日回响》《星尘之约》《心跳频率》。',
    photo: 'https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Chinese%20actor%20with%20calm%20eyes%2C%20soft%20neutral%20studio%20background%2C%20clean%20minimal%20lighting%2C%20professional%20photography%2C%20high%20detail&width=600&height=800&seq=actor-shenyibai-photo&orientation=portrait',
    filmIds: ['film-3', 'film-5', 'film-8', 'film-11'],
  },
];